import { render, staticRenderFns } from "./BigErrorBox.vue?vue&type=template&id=bb2c1da2&scoped=true&"
import script from "./BigErrorBox.vue?vue&type=script&lang=js&"
export * from "./BigErrorBox.vue?vue&type=script&lang=js&"
import style0 from "./BigErrorBox.vue?vue&type=style&index=0&id=bb2c1da2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2c1da2",
  null
  
)

export default component.exports